import { isNilOrEmpty } from 'ramda-extension';

import { appendMode, REQUEST_SIZE } from 'constants/general';
import fetch from 'features/common/fetch';
import { MY_DOCUMENTS_FORM_NAME } from 'features/views/productionControl/myDocuments/form';
import { SELECTION_CRITERIA_FORM_NAME } from 'features/views/productionControl/selectionCriteria/form';
import { cleanse, generateCommonFetchActions } from 'utils';

import { getUserIsSuperior } from '../selectors';
import {
	appendMyDocuments,
	resetDocumentsToReview,
	resetMyDocuments,
	setClientsMyDocuments,
	setMyDocuments,
	setMyDocumentsTotalRows,
	setUserIsSuperiorAndSubordinate,
} from '../slice';

export const fetchMyDocuments =
	() =>
	async (dispatch, getState, { getFormData }) => {
		const myDocumentsFormData = await getFormData(MY_DOCUMENTS_FORM_NAME);
		const selectionCriteriaFormData = await getFormData(SELECTION_CRITERIA_FORM_NAME);

		const queryParams = cleanse({
			waveId: selectionCriteriaFormData?.wave,
			policyNo: myDocumentsFormData?.policyNumber,
			documentState: myDocumentsFormData?.controlStatus,
			noticeFinalState: myDocumentsFormData?.centralConsent,
			documentType: myDocumentsFormData?.documentType,
			policyHolder: myDocumentsFormData?.client,
			size: REQUEST_SIZE,
			page: 0,
		});
		dispatch(fetchData({ queryParams }));
	};

export const fetchData =
	({ queryParams }, append = appendMode.SET) =>
	(dispatch, getState) => {
		const userIsSuperior = getUserIsSuperior(getState());

		dispatch(
			fetch.actions.get(fetch.constants.urls.koprMyDocuments, {
				queryParams,
				onSuccess: [
					(response) => () => {
						if (!response || !response.body) return;
						const data = response?.body?.data;
						const totalRows = response?.body?.pageMetaData?.totalRows;

						dispatch(append === appendMode.APPEND ? appendMyDocuments(data) : setMyDocuments(data));

						if (userIsSuperior) {
							if (!isNilOrEmpty(data)) {
								// superior + subordinate also > myDocuments is shown
								dispatch(setUserIsSuperiorAndSubordinate(true));
								dispatch(setMyDocumentsTotalRows(totalRows));
								dispatch(append === appendMode.APPEND ? appendMyDocuments(data) : setMyDocuments(data));
							} else {
								// only superior > myDocuments is hidden
								dispatch(resetMyDocuments());
							}
						} else {
							dispatch(resetDocumentsToReview());
							dispatch(append === appendMode.APPEND ? appendMyDocuments(data) : setMyDocuments(data));
						}
					},
				],
			}),
		);
	};

export const { loadSorted, loadMore, loadPage, reload } = generateCommonFetchActions(
	fetchData,
	fetch.constants.urls.koprMyDocuments,
);

export const fetchClientsMyDocuments =
	() =>
	async (dispatch, getState, { getFormData }) => {
		const selectionCriteriaFormData = await getFormData(SELECTION_CRITERIA_FORM_NAME);

		dispatch(
			fetch.actions.get(fetch.constants.urls.koprClientsMyDocuments, {
				queryParams: {
					waveId: selectionCriteriaFormData?.wave,
				},
				onSuccess: [
					(response) => () => {
						if (!response || !response.body) return;
						const data = response?.body;
						dispatch(setClientsMyDocuments(data?.values));
					},
				],
			}),
		);
	};
